/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const classNames = require('classnames')

const UnitsService = require('../../../../client/clientjs/services/units-service')
const WeatherService = require('../../../../client/clientjs/services/weather-service')

class WeatherData extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { translate, weatherData, locale, userSettings } = this.props

    const data = []
    data.push({
      icon: `wi wi-forecast-io-${weatherData.icon}`,
      display: translate(`weather.icons.${weatherData.icon}`),
      tooltip: translate(`weather.icons.${weatherData.icon}`),
    })
    data.push({
      icon: 'fas fa-thermometer-half',
      display: UnitsService.temperatureInUserSettings(weatherData.temperature, locale, userSettings, {
        withUnit: true,
      }),
      tooltip: translate('weather.iconTooltips.thermometer'),
    })

    let windValue = ''
    let bearing = 0
    if (typeof weatherData.windSpeed !== 'undefined') {
      windValue = `${(weatherData.windSpeed * 3.6).toLocaleString(undefined, {
        maximumFractionDigits: 0,
        useGrouping: false,
      })} km/h`
      bearing = weatherData.windBearing
    }
    data.push({
      icon: `wi wi-wind from-${bearing}-deg`,
      display: windValue,
      tooltip: translate('weather.iconTooltips.windBearing'),
    })

    data.push({
      icon: 'wi wi-barometer',
      display: weatherData.pressure > 0 ? `${Math.round(weatherData.pressure)}hPa` : '',
      tooltip: translate('weather.iconTooltips.barometer'),
    })

    let minMaxValue = ''
    if (weatherData.dayData) {
      minMaxValue = `${UnitsService.temperatureInUserSettings(
        weatherData.dayData.temperatureMin,
        locale,
        userSettings,
        { withUnit: true }
      )}/${UnitsService.temperatureInUserSettings(weatherData.dayData.temperatureMax, locale, userSettings, {
        withUnit: true,
      })}`
    }
    data.push({
      icon: 'fas fa-temperature-high',
      display: minMaxValue,
      tooltip: translate('weather.iconTooltips.thermometerMinMax'),
    })

    data.push({
      icon: 'wi wi-humidity',
      display: typeof weatherData.humidity !== 'undefined' ? `${Math.round(weatherData.humidity * 100)}%` : '',
      tooltip: translate('weather.iconTooltips.humidity'),
    })

    data.push({
      icon: 'fas fa-sunrise',
      display: weatherData.sunriseDisplay,
      tooltip: translate('weather.iconTooltips.sunrise'),
    })
    data.push({
      icon: 'fas fa-sunset',
      display: weatherData.sunsetDisplay,
      tooltip: translate('weather.iconTooltips.sunset'),
    })

    const moonPhase = weatherData.dayData ? WeatherService.moonIconFromMoonPhase(weatherData.dayData.moonPhase) : {}
    if (moonPhase.moonPhaseLabel) {
      data.push({
        icon: `wi ${moonPhase.moonIconName}`,
        display: translate(`weather.moonPhase.${moonPhase.moonPhaseLabel}`),
        tooltip: translate('weather.iconTooltips.moonPhase'),
      })
    }

    return (
      <div className="columns is-mobile is-multiline is-gapless is-centered">
        {data.map(elt => (
          <div
            key={elt.icon}
            className={classNames('column is-4 is-size-6', { tooltip: !!elt.tooltip })}
            data-tooltip={elt.tooltip}
          >
            <div
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              <span className="icon has-text-primary-blue">
                <i className={classNames(elt.icon)} />
              </span>
              <span className="has-text-weight-bold is-size-8">{elt.display}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

WeatherData.propTypes = {
  weatherData: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  userSettings: PropTypes.object,
}

WeatherData.defaultProps = {
  userSettings: {},
}

module.exports = withTranslator(WeatherData)
